 
 /* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import cx from 'classnames';

import helper from '../../helpers';
import utils from '../../../../lib/utils';
import Loading from '../../../common/Loading';
import closeIcon from '../../../../assets/images/close_icon_dark.svg';

import './index.scss';
import helpers from '../../helpers';

Modal.setAppElement('#root');

class SelectContact extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state={
      firstname:'',
      lastname:'',
      phone:'',
      email:'',
      error:{},
      selectedContact:{}
    }
  }

  componentDidMount(){
    if(this.props.advancedSearch.length===0 && !utils.isEmptyObject(this.props.createdContact)){
      this.selectedContactLocally(this.props.createdContact);
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.advancedSearch.length===0 && !utils.isEmptyObject(nextProps.createdContact)){
      this.selectedContactLocally(nextProps.createdContact);
    }
}

  closeModal() {
    this.props.setblockOverlayVisibility(false);
    this.setState({
      firstname:'',
      lastname:'',
      phone:'',
      email:'',
      error:{},
    })
  }

  handleChange = (event)=>{
    const errorObject = {...this.state.error};

    if(event.target.name==='firstname'||event.target.name==='lastname'){
      if(event.target.value.trim().length<1){
        errorObject[event.target.name] = 'Please enter a valid name';
      }else{
        delete errorObject[event.target.name];
      }
    }
    if(event.target.name==='phone') {
      if(!helper.validatePhoneNumber(event.target.value)){
        errorObject[event.target.name] = 'Please enter a valid phone number';
      }else{
        delete errorObject[event.target.name];
      }
    }
    if(event.target.name==='email') {
      if(!utils.isValidEmail(event.target.value)){
        errorObject[event.target.name] = 'Please enter a valid email';
      }else{
        delete errorObject[event.target.name];
      }
    }
    this.setState({
      [event.target.name]:event.target.value,
      error:errorObject
    })
  }
  sendButtonStatus =()=>{
    const { error, firstname, lastname, phone, email } = this.state;
    if( utils.isEmptyObject(error) && firstname.length>0 && lastname.length>0 && phone.length>0 && email.length>0){
      return false;
    }else{
      return true;
    }
  }
  getVaulesFromContact=(contact, key)=>{
    const email_phone = contact.contacts.filter(contact=>contact.type===key);
    if(email_phone && email_phone.length>0){
      return email_phone[0].value
    }else{
      return '';
    }
  }
  selectedContactLocally=(contact)=>{
    console.log('contact',contact)
    this.setState({
      selectedContact:contact
    })
  }
  createConversationWithContact=()=>{
    if(!utils.isEmptyObject(this.state.selectedContact)){
      console.log('data 3',this.state.selectedContact);
      this.props.selectContact(this.state.selectedContact)  
    }
  }
  generatedIdForContact=(contact)=>{
    let combinedId = ''
    if(contact.hasOwnProperty('first_name')){
       combinedId = contact.first_name+contact.last_name+contact.phone+contact.phone;
    }else{
       combinedId = contact.firstName+contact.lastName+this.getVaulesFromContact(contact,'PHONE')+this.getVaulesFromContact(contact,'EMAIL');
    }
    
    console.log('combinedId',combinedId,contact);
    return combinedId;
  }

  render() {
    const {modelopen,errorData, createdContact, advancedSearch, selectContact,editContact} = this.props;
    const { error, selectedContact } = this.state;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className="Modal"
          overlayClassName="overlay-top"
          contentLabel="Example Modal"
        >
          <div>
          <div>
            <div className="modal-header">
              <div className="title">{advancedSearch && advancedSearch.length>0?'Select Contact':'Review & Confirm'}</div>
              <button className="modal-close" onClick={this.closeModal}><img src={closeIcon}/></button>
              <div className="contacts-list">
              {advancedSearch.map(contact=>{
                return(
                  <div className={cx("constact-selection",{"active-contact":!utils.isEmptyObject(selectedContact)&& this.generatedIdForContact(selectedContact)===this.generatedIdForContact(contact) })} onClick={()=>this.selectedContactLocally(contact)}>
                   <div className="constact-selection_info">
                   {contact.name && <div className="constact-selection_info_name">{contact.name}</div>}
                    <div className="constact-selection_info_phone">{helpers.formatPhoneNumber(this.getVaulesFromContact(contact,'PHONE'))}</div>
                    {this.getVaulesFromContact(contact,'EMAIL') && <div className="constact-selection_info_email"><span className="val">{this.getVaulesFromContact(contact,'EMAIL')}</span></div>}
                 </div>
                 <div className="constact-selection_tag"><span className="tag">existing</span></div>
                  </div>)
              })}

              <div className={cx("constact-selection",{"active-contact":!utils.isEmptyObject(selectedContact)&& this.generatedIdForContact(selectedContact)===this.generatedIdForContact(createdContact) })} onClick={()=>this.selectedContactLocally(createdContact)}>
                <div className="constact-selection_info">
                {(createdContact.first_name ||createdContact.last_name) &&  <div className="constact-selection_info_name"><span>{createdContact.first_name}</span><span className="lastname">{createdContact.last_name}</span></div>}
                {createdContact.phone && <div className="constact-selection_info_phone">{helpers.formatPhoneNumber(createdContact.phone)}</div>}
                {createdContact.email && <div className="constact-selection_info_email"><span className="val">{createdContact.email}</span></div>}
                </div>
                <div className="constact-selection_tag"><span className="tag-new">new</span></div>
              </div>
              </div>
              <div className="actions-contact">
                  <button className="btn btn--primary btn--lg" onClick={this.createConversationWithContact} disabled={utils.isEmptyObject(selectedContact)}>
                    {advancedSearch && advancedSearch.length>0?((selectedContact && selectedContact.phone) ?'ADD NEW':'USE EXISTING'):('CONFIRM')}
                    </button>
                    <button className="btn btn--secondary btn--lg" onClick={editContact}>BACK</button>
              </div>
            </div>
          </div>
  
          {/* {(errorData.errorReportSucess && !errorData.postErrorReport ) &&
              <div className="modal-header">
              <div className="title">Blocking success</div>
              <button className="modal-close" onClick={this.closeModal}>X</button>
              <div className="sub-title">This number will not be allowed to text or call into TrueLark.
              </div>
              <div className="actions">
                  <button className="btn btn--primary btn--lg" onClick={this.closeModal}>
                    OK
                    </button>
              </div>
            </div>
            }  */}
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default SelectContact;

